import { createContext } from 'react';

const AudioPlayerContext = createContext({
});

export default AudioPlayerContext;